import component from "../legacy/UnavailableAlert"

export default component
